import { icons as a, phosphorIconVariants as e } from "./phosphor-icon-list.js";
const s = "https://cdn.scalar.com/icons/phosphor/2.1.1", p = "regular", h = (r) => {
  const [o, n, t] = r.startsWith("phosphor/") ? r.split("/") : ["phosphor", p, r];
  return { name: t, variant: n };
}, i = (r) => {
  const [o, n, t] = r.startsWith("phosphor/") ? r.split("/") : ["phosphor", p, r];
  return {
    name: t,
    variant: n
  };
};
function c(r) {
  const { variant: o, name: n } = h(r);
  return e.some((t) => t === o) ? a.includes(n) : !1;
}
function l(r) {
  const { variant: o, name: n } = i(r);
  return o === "regular" ? `${s}/${o}/${n}.svg` : `${s}/${o}/${n}-${o}.svg`;
}
function u(r, o) {
  return `phosphor/${o}/${r}`;
}
function f(r) {
  return e.map((o) => u(r, o));
}
const $ = {
  name: "phosphor",
  icons: a.flatMap((r) => f(r)),
  belongsToLibrary: c,
  resolveUrl: l
};
export {
  i as parsePhosphorIconKey,
  h as parseStringAsPhosphorIconKey,
  $ as phosphorLibrary
};
